import {Form} from 'formik';
import {useTranslation} from 'react-i18next';
import Input from '../../../../../../component/input/Input';
import InputList from '../../../../../../component/input/inputList/InputList';
import * as css from './CreateEventPopup.css';

interface CreateEventPopupFormProps {
    eventTypesList: Array<{key: string; text: string; permission: boolean | string}>;
}

function CreateEventPopupForm({eventTypesList}: CreateEventPopupFormProps) {
    const {t} = useTranslation('subscriptions');
    const {t: tLayout} = useTranslation('layout');

    return (
        <css.formContainer>
            <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
                <Input name="eventName" 
                    text={t('eventName')}
                    icon={undefined}
                    events={undefined}
                    className={undefined}
                    forwardRef={undefined}
                />
                <InputList 
                    name="eventType" 
                    text={t('eventKind')} 
                    list={eventTypesList}
                    t={tLayout}
                    icon={undefined}
                    className={undefined}
                    valid={undefined}
                    onFocus={undefined}
                > </InputList>
            </Form>
        </css.formContainer>
    );
}

export default CreateEventPopupForm;

